import { useEffect, useState, forwardRef, useImperativeHandle, Suspense, lazy,useRef } from "react";
import { InputGroup } from "react-bootstrap";
import { AutoComplete } from "../../AutoComplete/AutoComplete";
import ToolTip from "../../ToolTip/Tooltip";
import { GridView } from "../../GridView/GridView";
import {   
    buttonStyle,
    controlsProportion,
    initialWhere,
    initialWhereModal, 
} from "..";
import { AnimatedIconButton } from "../../AnimatedIconButton/AnimatedIconButton";
import { SvgComponent } from "../../SvgComponent/SvgComponent";
import usePaginationValuesWhere from "../../../Hooks/usePaginationValuesWhere";
import "../Lookup.style.css";
import IconButton from "../../IconButton/IconButton";
import {Simplebar} from "../../Simplebar/Simplebar";
import {BUSCAR_BARRIO} from "../../../Utils";


export const BarrioLookup = forwardRef(
    (
        {
            initialValue = { label: "", value: "" },
            onChange,
            isDisabled,
            municipioId,
            placement = "end"
        },
        ref
    ) => {
        const consultaActualId = useRef();

        const DEFAULT_PAGINATION_VALUES = {
            EsPaginable: true,
            CantidadPorPagina: 15,
            EsOrdernable: true,
            OrderBy: "IdSec",
            EsAscendente: false,
        };
        const simplebarRef = useRef(null);
        const [showCanvas, setShowCanvas] = useState(false);
        const [barrioListModal, setBarrioListModal] = useState([]);
        const [selectedValue, setSelectedValue] = useState({
            label: "",
            value: "",
        });
        const [whereModal, setWhereModal] = useState(initialWhereModal);
        const [pagination, setPagination] = useState({
            ...DEFAULT_PAGINATION_VALUES,
            OrderBy: "Nombre",
            Global: true,
            EsAscendente: true,
        });
        const { setPaginationValuesWhere } = usePaginationValuesWhere();

        useEffect(() => {
            if (whereModal != initialWhereModal) {
                buscar();
            }
        }, [whereModal]);

        useEffect(() => {
            if (selectedValue !== undefined && selectedValue !== null) {
                onChange(selectedValue);
            } else {
                setSelectedValue({ value: 0, label: "" });
            }
        }, [selectedValue]);

        useEffect(() => {
            if (initialValue && initialValue.value != selectedValue.value) {
                setSelectedValue(initialValue);
            }
        }, [initialValue.value]);
        const buscar2 = (url, cuerpo) => {
            return new Promise(function (resolve, reject) {
                // eslint-disable-next-line no-undef
                Citrus.AJAX.getJSON(url, cuerpo, function (respuesta) {
                    // eslint-disable-next-line no-undef
                    var datos = $.parseJSON(respuesta.d);
                    if (
                        datos &&
                        datos["Mensaje"] !== undefined &&
                        datos["Detalle"] !== undefined &&
                        datos["Interno"] !== undefined
                    ) {
                        reject(datos);
                    }
                    resolve(datos);
                });
            });
        };
        function buscar() {
            const whereWithPaginationValues = { ...whereModal, ...pagination };
            const obtenerDatos = () => {
                const consultaId = Math.random();
                consultaActualId.current = consultaId;
                const url = BUSCAR_BARRIO;
                buscar2(url, { where: {...whereWithPaginationValues, MunicipioId: (municipioId !== "" && municipioId !== null) ? municipioId : 0} }).then((data) => {
                    if (consultaId === consultaActualId.current) {
                        setPaginationValuesWhere(data, pagination, setPagination);
                        setBarrioListModal(data.Resultados);
                    }
                });
            };
            obtenerDatos();
        }

        const handleCerrar = () => {
            setShowCanvas(false);
            setWhereModal(initialWhereModal);
        };

        const onPageIndexChanging = (pageNumber) => {
            setPagination((prevstate) => {
                return { ...prevstate, IndiceDePagina: pageNumber - 1 };
            });
            setWhereModal({ ...whereModal });
        };

        const getSuggestions = async (value) => {
            const inputValue = value.trim().toLowerCase();
            let resp;
            const consultaId = Math.random();
            consultaActualId.current = consultaId;
            const url = BUSCAR_BARRIO;
            await buscar2(url, { where: {...initialWhere, MunicipioId: (municipioId !== "" && municipioId !== null) ? municipioId : 0, Nombre: inputValue} }).then((data) => {
                if (consultaId === consultaActualId.current) {
                    resp = data.Resultados;
                }
            });
            return resp;
        };

        useImperativeHandle(ref, () => ({
            clearSelection: () => {
                const clearValue = {
                    label: "",
                    value: null,
                };
                setSelectedValue(clearValue);
            },
        }));

        return (
            <div style={{paddingRight: '25px'}}>
                <InputGroup className="mb-2">
                    <div style={{ width: controlsProportion.input }}>
                        <AutoComplete
                            placeholder="Barrios"
                            getList={getSuggestions}
                            parentValue={selectedValue}
                            setParentValue={setSelectedValue}
                            isDisabled={isDisabled}
                        />
                    </div>
                    <div style={{ width: controlsProportion.button }}>
                        <AnimatedIconButton
                            size="40px"
                            height="18"
                            width="18"
                            message="Seleccionar Barrios"
                            useVendorTheme
                            style={buttonStyle}
                            disabled={isDisabled}
                            iconName="search"
                            onClick={() => {
                                setShowCanvas(true);
                                setTimeout(() => {
                                    buscar();
                                }, 200);
                            }}
                        />
                    </div>
                </InputGroup>
                {showCanvas && (
                    <Suspense>
                        <Simplebar
                            backdrop={true}
                            useVendorTheme
                            ref={simplebarRef}
                            placement={placement}
                            portal={false}
                            size="lg"
                            useLoading={true}
                            visible={showCanvas}
                            setShow={(e) => {
                                setShowCanvas(e);
                            }}
                            title="Seleccionar Barrio"
                            btnLeft={{
                                show: false,
                                func: () => {},
                            }}
                            btnRight={{
                                show: false,
                                func: () => {},
                            }}
                            scroll
                        >
                            <GridView
                                pagination={pagination}
                                setPagination={setPagination}
                                allowPaging={pagination.EsPaginable}
                                pageSize={pagination.CantidadPorPagina}
                                pageIndex={pagination.IndiceDePagina}
                                lastPageNumber={pagination.PaginasTotal}
                                dataSource={barrioListModal}
                                onPageIndexChanging={onPageIndexChanging}
                                where={whereModal}
                                setWhere={setWhereModal}
                            >
                                <GridView.Column
                                    isSticky
                                    bodyRenderer={(row) => {
                                        return (
                                            <div className="float-right">
                                                <IconButton
                                                    onClick={() => {
                                                        setSelectedValue({
                                                            label: row.Nombre,
                                                            value: row.Id,
                                                        });
                                                        handleCerrar();
                                                    }}
                                                >
                                                    <ToolTip message="Seleccionar">
                                                        <div>
                                                            <SvgComponent
                                                                height="20"
                                                                width="20"
                                                                iconName="check"
                                                            />
                                                        </div>
                                                    </ToolTip>
                                                </IconButton>
                                            </div>
                                        );
                                    }}
                                />
                                <GridView.Column
                                    headerText="Nombre"
                                    dataField="Nombre"
                                    sortExpression="Nombre"
                                />
                                <GridView.Column
                                    headerText="Número"
                                    dataField="Numero"
                                    sortExpression="Numero"
                                />
                            </GridView>
                        </Simplebar>
                    </Suspense>
                )}
            </div>
        );
    }
);
